<template>
    <v-container class="pa-0">
        <v-row>
            <v-col cols="3" class="py-0 pr-0">
                <v-subheader
                    style="font-size: 14px; line-height: 1.3"
                    class="pa-0 mb-1 subheader-class"
                    ><span><TranslatableStringComponent :tstring="{string: 'address'}" />:</span></v-subheader
                >
            </v-col>
            <v-col cols="9" class="py-0">
                <address class="mb-2">
                    {{ contact && contact.address1
                    }}<br v-if="contact && contact.address2" />{{
                        (contact && contact.address2) || ''
                    }}<br />{{ contact && contact.addressCity }},
                    {{ contact && contact.addressState }}
                    {{ contact && contact.addressPostalCode }}<br />
                    {{ contact && contact.addressCountry }}<br />
                </address>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" class="py-0 pr-0">
                <v-subheader
                    style="font-size: 14px; line-height: 1.3"
                    class="pa-0 mb-1 subheader-class"
                    ><span><TranslatableStringComponent :tstring="{string: 'phone'}" />:</span></v-subheader
                >
            </v-col>
            <v-col cols="9" class="mb-2 py-0">
                {{
                    `${
                        contact && contact.phone1CC
                            ? `+${contact.phone1CC}`
                            : ''
                    }  
                 ${(contact && contact.phone1) || '--'} 
                 
                    ${
                        contact && contact.phone1Ext
                            ? `Ext. ${contact.phone1Ext}`
                            : ''
                    }`
                }}</v-col
            >
        </v-row>
        <v-row>
            <v-col cols="3" class="py-0 pr-0">
                <v-subheader
                    style="font-size: 14px; line-height: 1.3"
                    class="pa-0 mb-1 subheader-class"
                    ><span><TranslatableStringComponent :tstring="{string: 'email'}" />:</span></v-subheader
                >
            </v-col>
            <v-col cols="9" class="mb-2 py-0">
                {{ (contact && contact.email1) || '--' }}
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'ContactCardDetails',
    components: {
        TranslatableStringComponent,
    },
    props: {
        contact: {
            type: Object,
            default: null,
        },
    },
}
</script>
<style scoped>
.subheader-class {
    height: 20px !important;
}
</style>
